'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var lib = require('../lib-26f8f706.js');
var text_index = require('./index.js');
require('tslib');
require('react');
require('classnames');
require('../utils-9a8db0ee.js');
require('../env-100217af.js');
require('styled-components');
require('../light-theme-colors-bb1a2999.js');

var H1Text = lib.variant('H1Text', text_index.Text, {
    container: 'h1',
    scale: text_index.FontScale.XXL,
    weight: text_index.FontWeight.HEAVIEST,
});
var H2Text = lib.variant('H2Text', text_index.Text, {
    container: 'h2',
    scale: text_index.FontScale.XL,
    weight: text_index.FontWeight.HEAVIEST,
});
var H3Text = lib.variant('H3Text', text_index.Text, {
    container: 'h3',
    scale: text_index.FontScale.L,
    weight: text_index.FontWeight.HEAVIEST,
});
var H4Text = lib.variant('H4Text', text_index.Text, {
    container: 'h4',
    weight: text_index.FontWeight.HEAVIEST,
});
var BodyLargeText = lib.variant('BodyLargeText', text_index.Text, {
    scale: text_index.FontScale.L,
});
var BodyMediumText = lib.variant('BodyMediumText', text_index.Text, {});
var BodySmallText = lib.variant('BodySmallText', text_index.Text, {
    scale: text_index.FontScale.S,
});
var TitleMediumText = lib.variant('TitleMediumText', text_index.Text, {
    weight: text_index.FontWeight.HEAVIER,
});
var TitleSmallText = lib.variant('TitleSmallText', text_index.Text, {
    scale: text_index.FontScale.S,
    weight: text_index.FontWeight.HEAVIER,
});
var PriceText = lib.variant('PriceText', text_index.Text, {
    weight: text_index.FontWeight.HEAVIEST,
});
var CaptionText = lib.variant('CaptionText', text_index.Text, {
    scale: text_index.FontScale.XS,
    emphasis: text_index.FontEmphasis.LOW,
});

Object.defineProperty(exports, 'Behavior', {
    enumerable: true,
    get: function () { return text_index.Behavior; }
});
Object.defineProperty(exports, 'FontColor', {
    enumerable: true,
    get: function () { return text_index.FontColor; }
});
Object.defineProperty(exports, 'FontEmphasis', {
    enumerable: true,
    get: function () { return text_index.FontEmphasis; }
});
Object.defineProperty(exports, 'FontScale', {
    enumerable: true,
    get: function () { return text_index.FontScale; }
});
Object.defineProperty(exports, 'FontWeight', {
    enumerable: true,
    get: function () { return text_index.FontWeight; }
});
exports.BodyLargeText = BodyLargeText;
exports.BodyMediumText = BodyMediumText;
exports.BodySmallText = BodySmallText;
exports.CaptionText = CaptionText;
exports.H1Text = H1Text;
exports.H2Text = H2Text;
exports.H3Text = H3Text;
exports.H4Text = H4Text;
exports.PriceText = PriceText;
exports.TitleMediumText = TitleMediumText;
exports.TitleSmallText = TitleSmallText;
//# sourceMappingURL=variants.js.map
